import React from "react";
import { Outlet, Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AddHomeOutlinedIcon from "@mui/icons-material/AddHomeOutlined";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import Logo from "../assets/images/logo.png";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
import WorkHistoryOutlinedIcon from "@mui/icons-material/WorkHistoryOutlined";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import { useState } from "react";
import { useEffect } from "react";
import {
  useMediaQuery
} from "@mui/material";



const HamburgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  
    const location = useLocation();
    const dispatch = useDispatch();
    const { pathname } = location;
    const splitLocation = pathname.split("/");
    const navigate = useNavigate();
    const [isAdmin, setIsAdmin] = useState(false);
  
    const [open, setOpen] = useState(false);
    const user = useSelector((state) => state.user);
    const userdata = sessionStorage.getItem("user");
    const allowedPermissions = userdata ? JSON.parse(userdata).permissions : {};
    const subScription = user.subScriptionStatus?.isSubscribed;
    const isMobile = useMediaQuery('(max-width:768px)');
  
    useEffect(() => {
      setTimeout(() => {
        const userdata = sessionStorage.getItem("user");
        setIsAdmin(userdata ? JSON.parse(userdata).is_admin : false);
        //setPermissions(userdata ? JSON.parse(userdata).is_admin : false);
      }, 1000);
    }, []);
  
    const dashboard = () => {
  
      navigate("/Dashboard");
      setIsOpen(!isOpen)
      //window.location.reload();
    }
  
    const logout = (e) => {
      e.preventDefault();
      sessionStorage.removeItem("access_token");
      sessionStorage.removeItem("user");
      navigate("/login");
      window.location.reload();
    };

  return (
    <div>
      {isMobile && (
        <>
          <div
            onClick={toggleMenu}
            style={{
              width: '30px',
              height: '15px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              cursor: 'pointer',
              margin: '10px',
            }}
          >
            {[...Array(3)].map((_, i) => (
              <div
                key={i}
                style={{
                  height: '2px',
                  backgroundColor: '#333',
                  borderRadius: '2px',
                }}
              />
            ))}
          </div>

          {/* Toggleable mobile menu */}
          {isOpen && (
            <div
              style={{
                position: 'absolute',
                top: '20px',
                left: 0,
                width: '80%',
                boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
              }}
            >
              
      <nav className="nav-position">
        <ul className="sidebar-ul" style={{padding:"0px 2px"}}>
          {/* <li className="sidebar-menuitems">
            <Link to="/" className="sidenavbar">
              <img className="sidenavbar-logo" src={Logo} />
            </Link>
          </li> */}
          <li
            className={
              splitLocation[1] === "Dashboard" ? "active" : "nonactive"
            }
          >
            <Link to="/Dashboard" className="sidenavbar" 
            onClick={toggleMenu} 
            style={{ color:"#000000",background:"none"}}>
              <GridViewOutlinedIcon className="nav_fill" fontSize="small" />
              <h6
                className="nav_fill"
                style={{
                  padding: "0px 0px",
                  margin: "0px 0px",
                  fontSize: "10px",
                  marginTop: "-5px",
                }}
              >
                Dashboard
              </h6>
            </Link>
          </li>
          <li
            className={
              splitLocation[1] === "userManagement" ? "active" : "nonactive"
            }
          >
            <Link to="/userManagement" className="sidenavbar"
            onClick={toggleMenu} 
            style={{ color:"#000000",background:"none"}}>
              <PersonAddOutlinedIcon className="nav_fill" fontSize="small" />
              <h6
                className="nav_fill"
                style={{
                  padding: "0px 0px",
                  margin: "0px 0px",
                  fontSize: "10px",
                  marginTop: "-5px",
                }}
              >
                User <br />
                Management
              </h6>
            </Link>
          </li>

          <li
            className={
              splitLocation[1] === "orgManagement" ? "active" : "nonactive"
            }
          >
            <Link to="/orgManagement" className="sidenavbar"
            onClick={toggleMenu} 
            style={{ color:"#000000",background:"none"}}>
              <AddHomeOutlinedIcon className="nav_fill" fontSize="small" />
              <h6
                className="nav_fill"
                style={{
                  padding: "0px 0px",
                  margin: "0px 0px",
                  fontSize: "10px",
                  marginTop: "-5px",
                }}
              >
                Org <br />
                Management
              </h6>
            </Link>
          </li>

          <li
            className={
              splitLocation[1] === "logManagement" ? "active" : "nonactive"
            }
          >
            <Link to="/logManagement" className="sidenavbar"
            onClick={toggleMenu} 
            style={{ color:"#000000",background:"none"}}>
              <AddHomeOutlinedIcon className="nav_fill" fontSize="small" />
              <h6
                className="nav_fill"
                style={{
                  padding: "0px 0px",
                  margin: "0px 0px",
                  fontSize: "10px",
                  marginTop: "-5px",
                }}
              >
                Log <br />
                Management
              </h6>
            </Link>
          </li>

          <li
            className={
              splitLocation[1] === "WorkManagement" ? "active" : "nonactive"
            }
          >
            <Link to="/WorkManagement" className="sidenavbar"
            onClick={toggleMenu} 
            style={{ color:"#000000",background:"none"}}>
              <WorkHistoryOutlinedIcon className="nav_fill" fontSize="small" />
              <h6
                className="nav_fill"
                style={{
                  padding: "0px 0px",
                  margin: "0px 0px",
                  fontSize: "10px",
                  marginTop: "-5px",
                }}
              >
                Work Queue <br />
                Management
              </h6>
            </Link>
          </li>

          <li
            className={splitLocation[1] === "Coupons" ? "active" : "nonactive"}
          >
            <Link to="/Coupons" className="sidenavbar"
            onClick={toggleMenu} 
            style={{ color:"#000000",background:"none"}}>
              <AddHomeOutlinedIcon className="nav_fill" fontSize="small" />
              <h6
                className="nav_fill"
                style={{
                  padding: "0px 0px",
                  margin: "0px 0px",
                  fontSize: "10px",
                  marginTop: "-5px",
                }}
              >
                Coupons
              </h6>
            </Link>
          </li>

          <li className={splitLocation[1] === "Plans" ? "active" : "nonactive"}>
            <Link to="/Plans" className="sidenavbar"
            onClick={toggleMenu} 
            style={{ color:"#000000",background:"none"}}>
              <SellOutlinedIcon className="nav_fill" fontSize="small" />
              <h6
                className="nav_fill"
                style={{
                  padding: "0px 0px",
                  margin: "0px 0px",
                  fontSize: "10px",
                  marginTop: "-5px",
                }}
              >
                Plans
              </h6>
            </Link>
          </li>

          <li
            className={splitLocation[1] === "Reports" ? "active" : "nonactive"}
          >
            <Link to="/Reports" className="sidenavbar"
            onClick={toggleMenu} 
            style={{ color:"#000000",background:"none"}}>
              <InsertChartOutlinedIcon className="nav_fill" fontSize="small" />
              <h6
                className="nav_fill"
                style={{
                  padding: "0px 0px",
                  margin: "0px 0px",
                  fontSize: "10px",
                  marginTop: "-5px",
                }}
              >
                Reports
              </h6>
            </Link>
          </li>
          <li className={splitLocation[1] === "/" ? "active" : "nonactive"}>
            <Link to="/" className="sidenavbar"
            onClick={logout} 
            style={{ color:"#000000",background:"none"}}>
              <LogoutOutlinedIcon
                fontSize="large"
                className="nav_fill"
                style={{
                  padding: "0px 0px",
                  margin: "0px 0px",
                }}
              />
              <h6
                className="nav_fill"
                style={{
                  padding: "0px 0px",
                  margin: "0px 0px",
                  fontSize: "10px",
                  marginTop: "-5px",
                }}
              >
                Logout
              </h6>
            </Link>
          </li>
        </ul>
      </nav>
            </div>
          )}
        </>
      )}
    </div>
  );
};

// Reusable style
const menuItemStyle = {
  display: 'block',
  padding: '10px 20px',
  textDecoration: 'none',
  color: '#333',
  fontWeight: 'bold',
};

export default HamburgerMenu;
